module.exports = __webpack_public_path__ + "img/logo.bf8e1fa0.png";